// import { Navigate } from "react-router-dom";
// import React from 'react'

// const ProtectedRoute = (props) => {
//     // console.log(':::::ProtectedRoute:::::;;;;;;', props)
//     const { children } = props
//     if (!localStorage.getItem('token')) {
//         return <Navigate to="/" />;
//     }
//     return children;
// };

// export default ProtectedRoute

import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = (props) => {
  // console.log(':::::ProtectedRoute:::::;;;;;;', props)
  const { children } = props;
  const location = useLocation();

  const token = localStorage.getItem("token");
  const userTempData = localStorage.getItem("userData");
  const userData = userTempData ? JSON.parse(userTempData) : {};
  // const role_id = userData?.roles[0]?.role_id;
  const role_id = userData?.roles?.[0]?.role_id;

  if (!token) {
    return <Navigate to="/" />;
  }

  // Restrict CSR (2) and CSR-R (3)
  if (role_id === 2) {
    const allowedPaths = [
      "/dashboard",
      "/profile",
      "/clinic-calendar-page",
      "/signal-details",
      "/gp-pricing",
      "/clinician-profile",
      "/abandoned-journey",
    ];
    const currentPath = location.pathname.toLowerCase();

    if (!allowedPaths.includes(currentPath)) {
      // Redirect CSR users trying to access forbidden pages
      return <Navigate to="/dashboard" />;
    }
  }
  // Restrict CSR-R (3) Pending Refunds
  if (role_id === 3) {
    const allowedPaths = [
      "/dashboard",
      "/profile",
      "/clinic-calendar-page",
      "/signal-details",
      "/pending-refunds",
      "/gp-pricing",
      "/clinician-profile",
    ];
    const currentPath = location.pathname.toLowerCase();

    if (!allowedPaths.includes(currentPath)) {
      // Redirect CSR users trying to access forbidden pages
      return <Navigate to="/dashboard" />;
    }
  }

  if (role_id === 4) {
    const allowedPaths = [
      "/dashboard",
      "/profile",
      "/product-categories",
      "/gp-product-admin",
      "/product-category",
      "/corporate-product",
      "/cancellation-rules",
      "/rescheduling-rules",
      "/corporate-customer",
      "/partner",            // IOO-325
      "/profile",
    ];
    const currentPath = location.pathname.toLowerCase();

    if (!allowedPaths.includes(currentPath)) {
      // Redirect CSR users trying to access forbidden pages
      return <Navigate to="/dashboard" />;
    }
  }

  return children;
};

export default ProtectedRoute;
